<template>
    <div class="popup" v-show="show">
        <div class="detail bg_white">
            <Icon class="closer cursor_pointer" type="md-close" @click="show=false" size="26"/>
            <div class="title f18 bold500 txt_black87 tc" v-if="flag==='create'">新建代理商</div>
            <div class="title f18 bold500 txt_black87 tc" v-if="flag==='view'">查看代理商</div>
            <div class="title f18 bold500 txt_black87 tc" v-if="flag==='edit'">编辑代理商</div>

            <div class="content">
                <div class="mask" v-if="flag==='view'"></div>
                <div class="left fl">
                    <div class="item txt_black54 f14 bold500">
                        <div class="title bold600 content-center">
                            <Icon type="ios-star"/>
                            姓名：
                        </div>
                        <div class="ipt">
                            <input class="w100 h100" type="text" placeholder="请输入姓名" v-model="data.name" />
                        </div>
                    </div>

                    <div class="item txt_black54 f14 bold500">
                        <div class="title bold600 content-center">
                            <Icon type="ios-star"/>
                            手机号：
                        </div>
                        <div class="ipt">
                            <input class="w100 h100" type="text" placeholder="请输入手机号" v-model="data.phone" />
                        </div>
                    </div>

                    <div class="item txt_black54 f14 bold500">
                        <div class="title bold600 content-center">
                            <Icon type="ios-star"/>
                            身份证号：
                        </div>
                        <div class="ipt">
                            <input class="w100 h100" type="text" placeholder="请输入身份证号" v-model="data.ID" />
                        </div>
                    </div>

                    <div class="item txt_black54 f14 bold500">
                        <div class="title bold600 content-center">
                            <Icon type="ios-star"/>
                            提现账户：
                        </div>
                        <div class="ipt">
                            <input class="w100 h100" type="text" placeholder="请输入提现账户" v-model="data.account" />
                        </div>
                    </div>
                    <div v-show="flag==='view'" class="item txt_black54 f14 bold500" >
                        <div class="title bold600 content-center">账户余额：</div>
                        <div>
                            <span v-text="data.balance"></span>
                        </div>
                    </div>
                </div>
                <div class="right fr">
                    <div class="item txt_black54 f14 bold500">
                        <div class="title bold600 content-center">
                            <Icon type="ios-star"/>
                            类别：
                        </div>
                        <selection :options="$config.agentType.getItem(2)" @change="typeChange"></selection>
                    </div>

                    <div class="item txt_black54 f14 bold500">
                        <div class="title bold600">
                            <Icon type="ios-star"/>
                            抽成比例（单位%）：
                        </div>
                        <div class="ipt">
                            <input class="w100 h100" min="0" max="100" type="number" placeholder="请输入抽成比例" v-model="data.commission" />
                        </div>
                    </div>
                    <div class="item txt_black54 f14 bold500">
                        <div class="title bold600">
                            <Icon type="ios-star"/>
                            备注：
                        </div>
                        <div class="area">
                            <textarea class="w100 txt_black54 f14 bold500" v-model="data.comment" ></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="submit tc">
                <button class="bg_E91E63 f18 bold400 txt_white tc cursor_pointer" @click="submitEvent">提交</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "",
        data() {
            return {
                show: false,
                flag: 'create',
                id: '',
                data: {
                    name: '',
                    phone: '',
                    ID: '',
                    account: '',
                    balance: '',
                    type: '',
                    commission: '',
                    comment: ''
                }
            }
        },
        methods:{
            init(flag,data) {
                this.flag = flag;
                this.show = true;
                if(flag !== 'create') {
                    this.id = data.id;
                    for(let v in this.data) {
                        this.data[v] = data[v];
                    }
                }else {
                    for(let v in this.data) {
                        this.data[v] = '';
                    }
                }
            },
            typeChange (data) {
                this.data.type = data.id;
            },
            submitEvent() {
                if(this.flag === 'create'){
                    this.$api.post('/manage/agent',this.data).then((data) => {
                        this.$alert.success({content: '新建代理商成功'});
                        this.show = false;
                        this.$emit('updateData');
                    }).catch((error) => {
                        this.$alert.error({content: '新建代理商失败'});
                    });
                }else {
                    this.$api.put('/manage/agent/' + this.id,this.data).then((data) => {
                        this.$alert.success({content: '修改成功'});
                        this.show = false;
                        this.$emit('updateData');
                    }).catch((error) => {
                        this.$alert.error({content: '修改失败'});
                    });
                }
            }
        }
    }
</script>

<style scoped>
    .detail {
        width: 600px;
    }

    .detail > .content {
        padding: 0 10px 10px 10px;
        overflow: auto;
        position: relative;
    }

    .detail > .content > .mask{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 20;
    }

    .content > .left, .content > .right {
        width: 48%;
        /*height: 400px;*/
    }

    .content > div > .item {
        margin-top: 15px;
    }

    .content > div > .item > div:nth-of-type(2) {
        height: 36px;
        line-height: 36px;
        margin-top: 8px;
    }

    .content > div > .item > .ipt {
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 3px;
    }

    .content > div > .item > div:nth-of-type(2) > :first-child {
        padding: 0 10px;
        display: inline-block;
    }

    .content > div > .item textarea {
        border: 1px solid rgba(204, 204, 204, 1);
        line-height: 20px;
        padding: 8px 10px !important;
        height: 116px;
    }
</style>